import { DomSanitizer, SafeResourceUrl, Meta, Title } from '@angular/platform-browser';
import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { TFMService } from 'app/mock-api/tfm.service';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar'
import { BannerSectionType01Component } from 'app/modules/client/banner-section/banner_section-type01/banner_section-type01.component';
import { FormsModule } from '@angular/forms';
import { forkJoin } from 'rxjs';
import { HeadingSectionType01Component } from 'app/modules/client/heading-section/heading_section-type01/heading_section-type01.component';


@Component({
  selector: 'app-promotional-type01',
  standalone: true,
  imports: [MatIconModule, RouterModule, MatTooltipModule, SlickCarouselModule, NgFor, NgIf, BannerSectionType01Component, FormsModule, NgClass, HeadingSectionType01Component],
  templateUrl: './promotional-type01.component.html',
  styleUrl: './promotional-type01.component.scss'
})
export class PromotionalType01Component implements OnInit {

  @Input() promotionalData: any;
  @Input('options') options: any = { showSlider: false };

  public view: any = {
    promotionalFiles: [],
    page: {},
    message: {}
  }

  constructor(private _tfmService: TFMService, private _cd: ChangeDetectorRef, private route: ActivatedRoute, private sanitizer: DomSanitizer, private _snackBar: MatSnackBar, private metaService: Meta, private title: Title) {

    this._tfmService.getContentBySection('xl-howzit-promo').then(res => {
      this.view.page = res;
      console.log(this.view.page);



      if (this.view.page.content.metaData) {
        this.view.metaDataContent = JSON.parse(this.view.page.content.metaData).general;
        // console.log(this.view.metaDataContent);
      }

      if (this.view.page && this.view.page?.content?.images && this.view.page?.content?.images.length > 0) {
        const image = this.view.page?.content?.images[0]; // Access the first image object
        const links = image._links; // Access the _links array

        // Find the link with rel "view"
        const viewLink = links.find((link: any) => link.rel === "view");

        // Get the href if the view link exists
        if (viewLink) {
          this.view.imageHref = viewLink.href;
          this._tfmService.log("Image href:", this.view.imageHref);
        } else {
          console.error("View link not found");
        }
      } else {
        console.error("Images not available");
      }

      this._tfmService.getSite().then((res) => {
        this.view.site = res;
        // console.log(res);

        this.view.site.profile = this._tfmService.getSiteProfile(
          this.view.site.profileID
        );
        // this._tfmService.log(this.view);

        if (this.view.page) {

          //Set title
          this.title.setTitle(this.view.page.content?.name + " - " + this.view.site?.name);

          // Set description & keywords
          this.metaService.updateTag({ name: 'description', content: this.view.page.content.seo.description });
          this.metaService.updateTag({ name: 'keywords', content: this.view.page.content.seo.keywords });
        }
      });
    });
  }

  modalOpen = false;
  customPackageModalOpen = false;
  customSelectedItem: any = null
  selectedItem: any = null;

  openModal(item:any ,index: number) {
    this.selectedItem = item;
    console.log(this.selectedItem);
    this.modalOpen = true;
  }

  openCustomPackageModal(index: number) {
    this.customSelectedItem = this.view.customSpecials[index];
    this.customPackageModalOpen = true;
  }

  closeModal() {
    this.modalOpen = false;
    this.selectedItem = null;
  }

  closeCustomPackageModal() {
    this.customSelectedItem = null;
    this.customPackageModalOpen = false;
  }

  isFormValid() {
    let valid = true;

    if (!this.view.message.firstName || !this.view.message.emailAddress)
      valid = false;
    return valid;
  }

  //Submit a message
  sendMessage() {
    this.view.message.isBusy = true;
    this.view.message.dateOfInquiry = new Date().toISOString();

    if (this.customPackageModalOpen && this.customSelectedItem?.name) {
      this.view.message.eventName = this.customSelectedItem.name;
    } else {
      this.view.message.eventName = this.view.site.name + ' - LMS Specials';
    }

    //create itinerary
    this._tfmService
      .createItin({
        description: this.view.message.eventName,
      })
      .subscribe((res) => {
        localStorage.setItem(
          this._tfmService.itinIdentifier,
          res.content.itinerary.guid
        );
        this.view.itin = res;

        // this.view.itin.content.itinerary.eventName = this.view.message.eventName;
        this.view.itin.content.itinerary.firstName = this.view.message.firstName;
        this.view.itin.content.itinerary.lastName = this.view.message.lastName;
        this.view.itin.content.itinerary.emailAddress = this.view.message.emailAddress;
        this.view.itin.content.itinerary.phoneNumber = this.view.message.phoneNumber;

        if (this.view.site.id == 146) { //Limit to XLTravel
          this._tfmService.addToLMS({
            "contact": {
              "firstName": this.view.itin.content.itinerary.firstName,
              "lastName": this.view.itin.content.itinerary.lastName,
              "email": this.view.itin.content.itinerary.emailAddress,
              "phone": this.view.itin.content.itinerary.phoneNumber
            },
            "deal": {
              "title": this.view.promoTitle,
              "description": this.view.message.comments,
              "currency": "ZAR",
              "value": 0
            }
          });

        }

        //Send the Updated itinerary
        this._tfmService
          .filterAndSend(
            this.view.itin.content.itinerary._links,
            'edit',
            this.view.itin.content.itinerary
          )
          .subscribe((res) => {
            let msg = { content: '' };
            msg.content +=
              (this.view.message.comments || '') + '\n';

            //Create message
            this._tfmService.createMessage(msg).subscribe((res) => {
              if (res == null) {
                this.view.message.status =
                  'Something went wrong' +
                  ' ' +
                  'Your Reference number is: ' +
                  ' ' +
                  this.view.itin.content.itinerary.reference;
              } else {
                this.view.message.status =
                  'Message Sent Successfully' +
                  ' ' +
                  'Your Reference number is: ' +
                  ' ' +
                  this.view.itin.content.itinerary.reference;
                this.showToast(
                  'Message sent successfully!',
                  'Close'
                );
                //  contactForm.resetForm();
              }
              this.view.message.isBusy = false;
            });
          });
      });
    this.modalOpen = false;
    this.customPackageModalOpen = false;
  }

  showToast(
    message: string,
    action: string = 'Close',
    duration: number = 3000
  ) {
    this._snackBar.open(message, action, {
      duration: duration,
    });
  }

  combineSpecialsAndPromotions() {
    // Map custom specials
    const customSpecialsMapped = (this.view.customSpecials || []).map((item: any, index: number) => {
      this._tfmService.log(`🟢 Custom Special [${index}]:`, item);

      const imageUrls = item.imageUrls && item.imageUrls.length > 0 ? item.imageUrls : [];
      
      // Wrap string URLs in an object structure { fileUrl: string }
      const imagesFormatted = imageUrls.map((url: string) => ({ fileUrl: url }));

      return {
        image: imagesFormatted[0]?.fileUrl || '', // Single image preview
        images: imagesFormatted,                 // Full image list for slider
        name: item.contentDescription || item.destination || 'Untitled Custom Special'
      };
    });

    this._tfmService.log("✅ Mapped Custom Specials: ", customSpecialsMapped);
    this._tfmService.log("✅ Custom Specials Count: ", customSpecialsMapped.length);

    // Map promotional files
    const promotionalFilesMapped = (this.view.promotionalFiles || []).map((item: any, index: number) => {
      this._tfmService.log(`🟣 Promo File [${index}]:`, item);

      const promoImages = (item.sanitizedPromotions || []).map((promo: any) => ({
        fileUrl: promo.fileUrl
      }));

      return {
        image: promoImages[0]?.fileUrl || '',
        images: promoImages,
        name: item.name || 'Untitled Promotion'
      };
    });

    // Combine both into one array for display
    this.view.allSpecialsCombined = [...customSpecialsMapped, ...promotionalFilesMapped];
  }


  getCustomSpecials(): Promise<void> {
    return this._tfmService
      .filterBundles({ rateType: 'pps', onlyActive: true }, false)
      .then((res) => {
        this.view.customSpecials = res.content.filter(item => item.tags && item.tags.includes('promotions'));
        this._tfmService.log("✅ Custom Specials Loaded:", this.view.customSpecials);
      });
  }

  getPromotionalContent() {
    // Fetch both categories - Update: Jacques
    forkJoin([
      this._tfmService.getXLPromotionalContent(158),
      this._tfmService.getXLPromotionalContent(159),
    ]).subscribe({
      next: ([response158, response159]) => {
        const today = new Date();

        // Combine both responses
        const combinedResponse = [...response158, ...response159];

        this.view.promotionalFiles = combinedResponse
          .filter((item: any) => {
            // Ensure specialsEnd exists and is a valid date
            if (!item.specialsEnd) return false;
            const expiryDate = new Date(item.specialsEnd);
            return today < expiryDate;
          })
          .map((item: any) => {
            let parsedFileName = [];
            try {
              // Parse the fileName JSON string
              parsedFileName = JSON.parse(item.fileName);
            } catch (error) {
              console.error(`Error parsing fileName for item ${item.name}:`, error);
            }

            // Filter parsedFileName for promotional files and sanitize their URLs
            const sanitizedPromotions = parsedFileName
              .filter((file: any) => file.fileLabel?.toLowerCase() === 'promotion')
              .map((file: any) => ({
                ...file,
                safeFileUrl: this.sanitizeUrl(file.fileUrl), // Sanitize after parsing
              }));

            return {
              ...item,
              sanitizedPromotions, // Attach sanitized promotional files to the item
              firstImage: sanitizedPromotions.length > 0 ? sanitizedPromotions[0].safeFileUrl : null,
            };
          })
          .filter((item: any) => item.sanitizedPromotions.length > 0);

        this.view.promoTitle = this.view.promotionalFiles[0]?.name;

        // Log the final filtered array
        this._tfmService.log('Filtered Promotional Files:', this.view.promotionalFiles);
        this._tfmService.log('Combined Specials:', this.view.allSpecialsCombined);
      },
      error: (error) => {
        console.error('Error fetching promotional content:', error);
      },
    });
  }

  sanitizeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

  slideConfig = {
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    infinite: true,
    dots: true,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  };

  // addSlide() {
  //   this.slides.push({img: "http://placehold.it/350x150/777777"})
  // }

  // removeSlide() {
  //   this.slides.length = this.slides.length - 1;
  // }

  slickInit(e) {
    this._tfmService.log('slick initialized');
  }

  breakpoint(e) {
    this._tfmService.log('breakpoint');
  }

  afterChange(e) {

  }

  beforeChange(e) {
  }

  ngOnInit(): void {
    this.getPromotionalContent();
    this.getCustomSpecials().then(() => {
      this.combineSpecialsAndPromotions();
    });
  }
}
